import { makeLMStyles } from "@launchmetrics/lm-ui";


export const useStyles = makeLMStyles(() => ({
	reportDropdownTitle: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		svg: {
			width: '20px',
			marginRight: '8px'
		}
	},
	reportForm: {
		selectorTitle: {
			position: 'relative',
			height: '32px',
			color: '#84848C',
			textTransform: 'uppercase',
			marginLeft: '10px !important',
			paddingTop: 'spacing-8',
			paddingLeft: 'spacing-8',
			paddingRight: 'spacing-8',
			paddingBottom: 'spacing-8',
			fontSize: '12px',
			fontWeight: 400,
			lineHeight: '16px',
			textAlign: 'left'
		}
	}
}));
